//import '../rocksure/scss/rocksure.scss'
import '../rocksure/scss/compiled.scss'
import '../rocksure/scss/custom.scss'

import "@babel/polyfill"
import "isomorphic-fetch"
import "@stimulus/polyfills"
import "../controllers"

import 'foundation-sites/dist/js/plugins/foundation.core';
import 'foundation-sites/dist/js/plugins/foundation.util.keyboard';
import 'foundation-sites/dist/js/plugins/foundation.util.box';
import 'foundation-sites/dist/js/plugins/foundation.util.triggers';
import 'foundation-sites/dist/js/plugins/foundation.util.mediaQuery';
import 'foundation-sites/dist/js/plugins/foundation.util.motion';
import 'foundation-sites/dist/js/plugins/foundation.dropdown';
import 'foundation-sites/dist/js/plugins/foundation.reveal';
import 'foundation-sites/dist/js/plugins/foundation.tooltip';
import 'foundation-sites/dist/js/plugins/foundation.smoothScroll';
import 'foundation-sites/dist/js/plugins/foundation.tabs';

import $ from "jquery";
window.$ = window.jQuery = $;

import "../rocksure/public";
import "../rocksure/destinations";